<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { Label } from '#ui-kit/ui/label'

const props = defineProps<{
  for?: string
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <Label
    data-slot="field-label"
    :for="props.for"
    :class="
      cn(
        'flex items-center gap-1 text-sm leading-5 font-normal text-secondary md:[[data-slot=field][data-orientation=horizontal]>&]:min-h-10 md:[[data-slot=field][data-orientation=horizontal]>&]:w-1/2 md:[[data-slot=field][data-orientation=horizontal]>&]:shrink-0',
        props.class,
      )
    "
  >
    <slot />
  </Label>
</template>
